export default __webpack_public_path__ + "static/media/logo.f1dc47f8.png";